import { PropsWithChildren } from "react";
import "./ProductPageOption.css";

export default function ProductPageOption({ children }: PropsWithChildren<{}>) {
  return <span id="product-page-option">{children}</span>;
}
